import { phoneNumber as phoneValidator } from "helpers/validators";
import React, { Component } from "react";

const CONSIGNEE_MESSAGES = {
    start: "Введите номер телефона в формате +7XXXXXXXXXX",
    load: "Проверка существования номера...",
    success: "Номер существует, Имя пользователя добавлено",
    error: "Номер не найден. Введите имя пользователя чтобы создать его.",
};

export default class ContactInfo extends Component {
    state = {
        isLoading: false,
        currentMessage: "",
    };

    setConsigneeValue = ({ name, value }) => {
        const { fieldName, getContactInfo, contact, setValue } = this.props;
        if (name === "phoneNumber") {
            if (!phoneValidator(value)) {
                this.setState({ currentMessage: CONSIGNEE_MESSAGES.load, isLoading: true });
                getContactInfo({ phoneNumber: value }).then((res) => {
                    if (res && res.name) {
                        this.setState({ currentMessage: CONSIGNEE_MESSAGES.success, isLoading: false });
                        this.setConsigneeValue({ name: "name", value: res.name });
                    } else {
                        this.setState({ currentMessage: CONSIGNEE_MESSAGES.error, isLoading: false });
                    }
                });
            } else {
                this.setState({ currentMessage: "", isLoading: true });
            }
        }
        setValue({ name: fieldName, value: { ...contact, [name]: value } });
    };

    handleConsignee = () => {
        const { contact } = this.props;
        if (contact.phoneNumber && contact.name) {
            this.setState({ currentMessage: CONSIGNEE_MESSAGES.success });
        } else if (contact.phoneNumber) {
            this.setState({ currentMessage: CONSIGNEE_MESSAGES.error });
        }
    };

    currentMessage = () => {
        if (this.state.currentMessage.length) {
            return (
                <small className="text-info offset-sm-4 offset-md-3 col-sm-8 col-md-5">
                    {this.state.currentMessage}
                </small>
            );
        }
    };

    render() {
        const { contact, renderField, config } = this.props;
        if (!config) {
            return null;
        }
        return (
            <>
                <div className="form-group">
                    {renderField({
                        ...config.name,
                        onChange: this.setConsigneeValue,
                        value: contact ? contact.name : "",
                    })}
                    {renderField({
                        ...config.number,
                        onChange: this.setConsigneeValue,
                        value: contact ? contact.phoneNumber : "",
                    })}
                    {this.currentMessage()}
                </div>
            </>
        );
    }
}
